export const updateLoggedInUser = (data) => {
  return { type: "UPDATE", data };
};

export const clearUserData = () => {
  return { type: "CLEAR" };
};
